import { StyleProps } from '../../types';

export default (theme: any) => ({
  divider: {
    backgroundColor: theme.palette.primarySeparatorColor,
    marginBottom: ({ isCommentsMode }: StyleProps) =>
      isCommentsMode ? 20 : 16,
  },
});
